import moment from 'moment';

const columnConfig = [
  {
    title: 'columns.date',
    accessor: row =>
      new moment(row.createdAt).format(moment.localeData().longDateFormat('L')),
    name: 'createdAt',
    filterable: false,
    sortable: false,
    width: 100,
  },
  {
    title: 'common.shared.content',
    accessor: 'content',
    name: 'content',
    filterable: false,
    sortable: false,
  },
];

export default columnConfig;
